var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "col-7 col-xl-2 col-lg-2 col-md-2 d-flex justify-content-end align-items-center d-lg-block d-xl-block d-xl-block job-info"
    },
    [
      _c(
        "span",
        { staticClass: "d-flex d-lg-none d-xl-none d-md-none price-per-hour" },
        [_vm._v("\n    $" + _vm._s(_vm.job.price_per_hour) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.canCreateClaim && !_vm.hasClaim
        ? _c(
            "button",
            {
              staticClass: "btn btn-primary create-claim-button",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$emit("createClaim", true)
                }
              }
            },
            [_vm._v("\n    Create claim\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.job.status_id !== 40
        ? _c(
            "div",
            {
              staticClass:
                "float-right float-xl-right float-md-right float-lg-right order-2"
            },
            [
              _vm.$_can("jobs.status.update") ||
              _vm.$_can("jobs.carrier.assign") ||
              _vm.$_can("jobs.status.revert.accepted") ||
              _vm.$_can("jobs.status.revert.total_time")
                ? _c("div", { staticClass: "dropdown" }, [
                    _c("button", {
                      staticClass: "btn btn-secondary add-filter",
                      attrs: {
                        type: "button",
                        id: "dropdownMenuButton",
                        disabled: !_vm.hasAccess,
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-menu dropdown-menu-right",
                        attrs: { "aria-labelledby": "dropdownMenuButton" }
                      },
                      [
                        _vm.job.cash_collected !== null &&
                        _vm.$_can("jobs.set-cash-collected") &&
                        _vm.canShowCashCollect
                          ? [
                              _c(
                                "button",
                                {
                                  staticClass: "dropdown-item nav-link btn",
                                  on: {
                                    click: function($event) {
                                      _vm.cashCollectModal = true
                                    }
                                  }
                                },
                                [
                                  !_vm.job.cash_collected
                                    ? [
                                        _vm._v(
                                          "\n              Cash collect\n            "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n              Cash not collected\n            "
                                        )
                                      ]
                                ],
                                2
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.job.status_id === 16
                          ? [
                              _vm.$_can("jobs.status.revert.total_time")
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item nav-link btn",
                                      on: {
                                        click: function($event) {
                                          _vm.$emit("showRevertToTotalTime")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Revert to total time\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : [
                              _vm.job.carrier === null ||
                              _vm.job.status_id === 31
                                ? [
                                    _vm.$_can("jobs.carrier.assign")
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "dropdown-item nav-link btn",
                                            on: {
                                              click: function($event) {
                                                _vm.$emit(
                                                  "showCarrierReassignModal",
                                                  true
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              Assign carrier\n            "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.job.status_id !== 30 &&
                                    _vm.$_can("jobs.status.update")
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "dropdown-item nav-link btn",
                                            on: {
                                              click: function($event) {
                                                _vm.$emit(
                                                  "showModalCancelJob",
                                                  true
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              Cancel\n            "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                : [
                                    _vm.job.status_id === 1
                                      ? [
                                          _vm.$_can("jobs.carrier.assign")
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "dropdown-item nav-link btn",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "showCarrierReassignModal",
                                                        true
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                Assign carrier\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.job.status_id === 2
                                      ? [
                                          _vm.job.status_id !== 31 &&
                                          _vm.$_can("jobs.status.update")
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "dropdown-item nav-link btn",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "showModalAcceptJob",
                                                        true
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                Accept\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.job.status_id !== 31 &&
                                          _vm.$_can("jobs.status.update")
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "dropdown-item nav-link btn",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "showModalRejectJob",
                                                        true
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                Reject\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$_can("jobs.carrier.assign")
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "dropdown-item nav-link btn",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "showCarrierReassignModal",
                                                        true
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                Assign carrier\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.job.status_id !== 30 &&
                                          _vm.$_can("jobs.status.update")
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "dropdown-item nav-link btn",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "showModalCancelJob",
                                                        true
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                Cancel\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.job.status_id === 3
                                      ? [
                                          _vm.$_can("jobs.status.update")
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "dropdown-item nav-link btn",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "changeToInProgress"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                In progress\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$_can("jobs.carrier.assign")
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "dropdown-item nav-link btn",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "showCarrierReassignModal",
                                                        true
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                Assign carrier\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "dropdown-item nav-link btn",
                                              on: {
                                                click: function($event) {
                                                  _vm.$emit(
                                                    "showModalIsSmallJob",
                                                    true
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                Change job size\n              "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.job.status_id !== 30 &&
                                          _vm.$_can("jobs.status.update")
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "dropdown-item nav-link btn",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$emit(
                                                        "showModalCancelJob",
                                                        true
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                Cancel\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm._e()
                                  ],
                              _vm._v(" "),
                              (_vm.job.status_id === 1 ||
                                _vm.job.status_id === 2 ||
                                _vm.job.status_id === 3 ||
                                _vm.job.status_id === 31) &&
                              _vm.job.status_id !== 21 &&
                              _vm.$_can("jobs.status.update")
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item nav-link btn",
                                      on: {
                                        click: function($event) {
                                          _vm.$emit("changeToOnHold")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            On Hold\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.canRevertToAccepted &&
                              _vm.$_can("jobs.status.revert.accepted")
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item nav-link btn",
                                      on: {
                                        click: function($event) {
                                          _vm.$emit("showRevertToAccepted")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Revert to accepted\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (_vm.job.status_id === 30 ||
                                _vm.job.status_id === 21) &&
                              _vm.$_can("jobs.status.update")
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item nav-link btn",
                                      on: {
                                        click: function($event) {
                                          _vm.restoreStatus()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Restore\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$_can("jobs.assign")
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item nav-link btn",
                                      on: {
                                        click: function($event) {
                                          _vm.$emit("reassignUserModal")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Assign user\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.job.status_id === 31 &&
                              _vm.$_can("jobs.status.update")
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item nav-link btn",
                                      on: {
                                        click: function($event) {
                                          _vm.$emit("returnToPending")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Return To Pending\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$_can("jobs.status.update") &&
                              !_vm.job.is_flat_rate
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item nav-link btn",
                                      on: { click: _vm.sendContractEmail }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Send pre-agreement\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "dropdown-item nav-link btn",
                                  on: {
                                    click: function($event) {
                                      _vm.showModalRegistrationUrl = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            Send registration url\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.canSendEpayLink
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item nav-link btn",
                                      on: {
                                        click: function($event) {
                                          _vm.$emit("showSendEpayLink")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Send E-pay Link\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.job.status_id === 40
        ? _c(
            "div",
            {
              staticClass:
                "float-right float-xl-right float-md-right float-lg-right order-2"
            },
            [
              _vm.$_can("jobs.status.update") ||
              _vm.$_can("jobs.carrier.assign")
                ? _c("div", { staticClass: "dropdown" }, [
                    _c("button", {
                      staticClass: "btn btn-secondary add-filter",
                      attrs: {
                        type: "button",
                        id: "dropdownMenuButtonInProgress",
                        disabled: !_vm.hasAccess,
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-menu dropdown-menu-right",
                        attrs: {
                          "aria-labelledby": "dropdownMenuButtonInProgress"
                        }
                      },
                      [
                        [
                          _vm.canRevertToAccepted &&
                          _vm.$_can("jobs.status.revert.accepted")
                            ? _c(
                                "button",
                                {
                                  staticClass: "dropdown-item nav-link btn",
                                  on: {
                                    click: function($event) {
                                      _vm.$emit("showRevertToAccepted")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            Revert to accepted\n          "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.job.status_id !== 30 &&
                          _vm.$_can("jobs.status.update")
                            ? _c(
                                "button",
                                {
                                  staticClass: "dropdown-item nav-link btn",
                                  on: {
                                    click: function($event) {
                                      _vm.$emit("showModalCancelJob", true)
                                    }
                                  }
                                },
                                [_vm._v("\n            Cancel\n          ")]
                              )
                            : _vm._e()
                        ]
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.changes.length && _vm.job.status_id !== 16
        ? _c(
            "button",
            {
              staticClass: "btn btn-primary btn-changes float-lg-right",
              attrs: { type: "button", disabled: !_vm.hasAccess },
              on: { click: _vm.loadJobChanges }
            },
            [
              _c("span", {
                staticClass: "mod-icon-edit mod-icon-mailing",
                attrs: { "aria-hidden": "true" }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalChanges
        ? _c("job-changes", {
            attrs: {
              changes: _vm.changes,
              "model-id": _vm.job.id,
              sending: _vm.job.company.send_automatic_emails
            },
            on: {
              close: function($event) {
                _vm.showModalChanges = false
              },
              ok: _vm.updateEmailSent
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMovingContractButton
        ? _c(
            "button",
            {
              staticClass: "btn btn-danger btn-changes float-lg-right",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$emit("toggleEmailConfirmationModal")
                }
              }
            },
            [_c("span", { staticClass: "mod-icon-edit mod-icon-mailing" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEmailConfirmationModal
        ? _c("send-email-confirmation", {
            attrs: { "job-id": _vm.job.id },
            on: { sent: _vm.contractSent }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalRegistrationUrl
        ? _c(
            "modal",
            {
              attrs: { size: "modal-large", "close-strict": false },
              on: {
                close: function($event) {
                  _vm.showModalRegistrationUrl = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-10" }, [
                    _c("div", [_c("h4", [_vm._v("Link to be sent")])])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { id: "booking-link", type: "text", readonly: "" },
                    domProps: { value: _vm.registerUrl }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "input-group-append pointer",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          _vm.copyToClipboard(
                            _vm.registerUrl,
                            "Successfully copied to clipboard"
                          )
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-text" }, [
                        _c("span", [
                          _c("i", { staticClass: "fa fa-copy list-box-icon" })
                        ])
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", {
                  staticClass:
                    "d-flex align-items-center justify-content-end w-100"
                })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cashCollectModal
        ? _c(
            "modal",
            {
              attrs: { size: "modal-large", "close-strict": false },
              on: {
                close: function($event) {
                  _vm.cashCollectModal = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                !_vm.job.cash_collected
                  ? _c("h4", [_vm._v("\n        Cash collect\n      ")])
                  : _c("h4", [_vm._v("\n        Cash not collected\n      ")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    !_vm.job.cash_collected
                      ? [
                          _vm._v(
                            "\n          This will mark that the cash was collected for this job. Do you want to proceed?\n        "
                          )
                        ]
                      : [
                          _vm._v(
                            "\n          This will mark that the cash was not collected for this job. Do you want to proceed?\n        "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-center mt-3",
                    staticStyle: { gap: "15px" }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.cashCollectModal = false
                          }
                        }
                      },
                      [_vm._v("\n          No\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.setCashCollected }
                      },
                      [_vm._v("Yes")]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", {
                  staticClass:
                    "d-flex align-items-center justify-content-end w-100"
                })
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b1e9f7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b1e9f7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobInfo.vue
// module id = null
// module chunks = 